import React from 'react';
import Description from './Description';
import classNames from 'classnames';
import Helmet from 'react-helmet';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import OnVisible, { setDefaultProps } from 'react-on-visible';

setDefaultProps({
    bounce: true,
    visibleClassName: 'is-visible',
    percent: 10,
});

const FULL = 'Full width';
const HALF = 'Half width';

const terms = {
  fr: {
    CLIENT: 'Client',
    COLLABORATOR: 'Collaborateur(s)',
    YEAR: 'Année',
  },
  en: {
    CLIENT: 'Client',
    COLLABORATOR: 'Collaborator(s)',
    YEAR: 'Year',
  }
}

class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };

    this.onImageLoad = this.onImageLoad.bind(this);
  }

  onImageLoad() {
    this.setState({ loaded: true });
  }

  componentDidMount() {
    const imgSrc = this.props.src;
    const img = new window.Image();
    img.onload = this.onImageLoad;
    img.src = imgSrc;
  }

  render() {
    const { className, src, placeholderSrc, ...props } = this.props;
    const imgClasses = 'image';
    const rootClassName = classNames(className, 'image', {
      'image-loaded': this.state.loaded,
    });
    return (
      <OnVisible className="image-container">
        <div className="image-wrapper">
          <img
            ref={(img) => { this.img = img; }}
            src={this.state.loaded ? src : placeholderSrc}
            {...props}
            className={rootClassName}
          />
        </div>
      </OnVisible>
    );
  }
}

class SingleProject extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opacity: 0,
      projectHeight: false,
      isSticky: false,
    };

    this.updateBgColor = debounce(this.updateBgColor.bind(this), 2);
    this.wrapperHeight = debounce(this.wrapperHeight.bind(this), 10);
    this.stickyProject = debounce(this.stickyProject.bind(this), 2);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    window.addEventListener('scroll', this.updateBgColor);
    window.addEventListener('scroll', this.stickyProject);
    window.addEventListener('resize', this.wrapperHeight);
    window.addEventListener('scroll', this.wrapperHeight);

    this.props.setNavAltColor(true);
    this.wrapperHeight();
    this.updateBgColor();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateBgColor);
    window.removeEventListener('scroll', this.stickyProject);
    window.removeEventListener('resize', this.wrapperHeight);
    window.removeEventListener('scroll', this.wrapperHeight);

    this.props.setNavAltColor(false);
  }

  wrapperHeight() {
    if (this.projectWrapper) {
      const projectHeight = Math.max(
        this.projectWrapper.clientHeight,
        this.projectWrapper.scrollHeight,
        this.projectWrapper.offsetHeight
      );

      if (projectHeight !== this.state.projectHeight) {
        this.setState({
          projectHeight,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevId = this.props.match.params.id;
    const nextId = nextProps.match.params.id;

    if (prevId !== nextId) {
      window.scrollTo(0, 0);
      this.props.setNavAltColor(true);
    }

    if (this.props.mainHeight !== nextProps.mainHeight) {
      this.wrapperHeight();
    }
  }

  updateBgColor() {
    if (!this.projectRef) {
      return;
    }

    const offset = this.projectRef.getBoundingClientRect();
    const top = offset.top;
    const height = this.projectRef.clientHeight;
    const viewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const diff = top + height + viewportHeight;
    const percent =
      top === 0 && diff <= viewportHeight
        ? 0
        : ((diff - viewportHeight) / viewportHeight).toFixed(2);

    // const opacity = (percent > 1) ? 0 : 1 - percent;
    let opacity = 0;

    if (percent > 1) {
      opacity = 0;
    } else if (percent <= 0) {
      opacity = 1;
    } else {
      opacity = 1 - percent;
    }

    // if (top === 0) {
    //   return;
    // }

    // console.log(top, height, viewportHeight, diff, percent, opacity);
    this.setState({
      opacity,
    });
  }

  stickyProject() {
    const contentTop = 0;
    const { projectHeight } = this.state;
    const windowScrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement ||
            document.body.parentNode ||
            document.body).scrollTop;

    // if(windowScrollTop === 0) {
    // this.setState({
    //   isSticky: false,
    // });
    // return;
    // }

    if (!projectHeight) {
      return;
    }

    // console.log(projectHeight, windowScrollTop, contentTop + projectHeight - window.innerHeight);

    if (windowScrollTop >= contentTop + projectHeight - window.innerHeight) {
      this.setState({
        isSticky: true,
      });
    } else {
      this.setState({
        isSticky: false,
      });
    }
  }

  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  renderProject() {
    const { project } = this.props;

    if (!project) {
      console.log('project is null');
      return null;
    }

    const images = project.getGroup('project.images').toArray();
    const color = this.hexToRgb(project.getColor('project.color'));
    const lang = this.props.match.params.lang || 'fr';

    const r = Math.floor(255 - (255 - color.r) * this.state.opacity);
    const g = Math.floor(255 - (255 - color.g) * this.state.opacity);
    const b = Math.floor(255 - (255 - color.b) * this.state.opacity);

    const collaborators = project.getStructuredText('project.collaborators');
    const description = project.getStructuredText('project.description');
    const client = project.getStructuredText('project.client');
    const date = project.getText('project.date');

    const title = get(this.props, 'site.title', '') +
    ' — ' +
    project.getText('project.title');

    // console.log(title,title)

    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content={project.getStructuredText('project.description').asText()}
          />
        </Helmet>
        <div
          className="single-project__top-bar"
          style={{
            backgroundColor: `rgb(${r}, ${g}, ${b})`,
          }}
        />
        <Description id={project.uid}>
          <span>
            <span className="single-project__category">
              {project.getText('project.category')}&nbsp;&#x2192;&nbsp;
            </span>
            <span
              className="single-project__description"
              dangerouslySetInnerHTML={{ __html: description.asText() }}
            />
            <dl>
              {client &&
                <div>
                  <dt>{terms[lang].CLIENT}</dt>
                  <dd
                    className="single-project__client"
                    dangerouslySetInnerHTML={{ __html: client.asHtml() }}
                  />
                </div>}
              {collaborators &&
                <div>
                  <dt>{terms[lang].COLLABORATOR}</dt>
                  <dd
                    className="single-project__collaborators"
                    dangerouslySetInnerHTML={{ __html: collaborators.asHtml() }}
                  />
                </div>}
              {date &&
                <div>
                  <dt>{terms[lang].YEAR}</dt>
                  <dd className="single-project__date">
                    {date}
                  </dd>
                </div>}
            </dl>
          </span>
        </Description>
        <div
          className="single-project__images"
          ref={imagesContainer => (this.imagesContainer = imagesContainer)}
          style={{
            backgroundColor: `rgb(${r}, ${g}, ${b})`,
          }}
        >
          {images.map((image, i) => {
            if (!this.imagesContainer) {
              return null;
            }

            const img = image.getImage('image');
            const layout = get(image.get('layout'), 'value', FULL);
            const ratio = img.main.height / img.main.width;
            const containerWidth = this.imagesContainer.clientWidth;
            const lazyHeight =
              containerWidth > img.main.height
                ? img.main.height
                : containerWidth * ratio;

            // return (
            //   <LazyLoad
            //     key={i}
            //     minheight={lazyHeight}
            //     offset={200}
            //     once
            //     // debounce={500}
            //     placeholder={<img
            //       className={classNames('project-image', {
            //         'is-half': (layout === HALF),
            //         'is-full': (layout === FULL),
            //       })}
            //       src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            //       height={img.main.height}
            //       width={img.main.width}/>}
            //   >
            //     <img
            //       key={i}
            //       className={classNames('project-image', {
            //         'is-half': (layout === HALF),
            //         'is-full': (layout === FULL),
            //       })}
            //       src={img.main.url}
            //       width={img.main.width}
            //       height={img.main.height}
            //     />
            //   </LazyLoad>
            // );
            return (
              <Image
                key={`${this.props.match.params.id}-${i}`}
                className={classNames('project-image', {
                  'is-half': layout === HALF,
                  'is-full': layout === FULL,
                })}
                placeholderSrc="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                src={img.main.url}
                width={img.main.width}
                height={img.main.height}
              />
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className="single-project"
        ref={projectRef => (this.projectRef = projectRef)}
        style={{
          height: this.state.projectHeight,
        }}
      >
        <div
          className={classNames('single-project__wrapper', {
            'is-sticky': this.state.isSticky,
          })}
          ref={projectWrapper => (this.projectWrapper = projectWrapper)}
        >
          {this.props.project && this.renderProject()}
        </div>
      </div>
    );
  }
}

SingleProject.defaultProps = {
  project: PropTypes.object.isRequired,
}

export default SingleProject;



// WEBPACK FOOTER //
// ./src/components/SingleProject.js